import { IPageSeo } from '../../types/page';
import { IApplicationState } from '../../types/redux';

export function selectPageSeo(state: IApplicationState): IPageSeo {
  return {
    h1: state.seoData.h1,
    pageDescription: state.seoData.pageDescription,
    promoCategoryDetails: state.seoData.promoCategoryDetails,
  };
}
